










































































/** @format */

import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import Utils from '@/utils/common';
import moment from 'moment';
// import PlateInput from '../../../components/plate-input/index.vue'
// 导入字典
import { dicDesshiyouhMap } from '@/types/special-authorized-car-management/dictionaries';

import { PACKAGE_MANAGEMENT } from '@/views/discount-management/router-names.ts';
import { COUPON_SEND_LIST } from '@/views/discount-management/router-names.ts';

// axios请求
import { getpageListye } from '@/api/discount-management/index';

@Component({
  name: 'VoucherIssuanceRecord',
  components: {
    ParkingLotSearch
    // PlateInput,
  }
})
export default class VoucherIssuanceRecord extends Mixins(TableMixin, TableWidthMixin) {
  @Prop()
  id!: any;

  dateTime = [];
  operateType = '';
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 100,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '余额变动原因',
        dataIndex: 'operateTypeName',
        width: 190,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '变动额度',
        dataIndex: 'changeQuota',
        width: 160,
        customRender: (text: any) => text || '--'
      },
      {
        title: '账户余额',
        dataIndex: 'residueQuota',
        width: 190,
        // customRender: (text: any) => text || '--',
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '余额变动时间',
        dataIndex: 'operateTime',
        width: 220,
        customRender: (text: any) => text || '--'
      },
      {
        title: '套餐名称',
        dataIndex: 'packageName',
        width: 240,
        // scopedSlots: { customRender: 'areaSurNum' },
        customRender: (text: any) => text || '--'
      },

      {
        title: '优惠类型',
        dataIndex: 'packageTypeName',
        width: 110,
        // customRender: (text: any) => dictAlonePayMap[text],
        customRender: (text: any) => text || '--'
      }
      // {
      //   title: '操作',
      //   dataIndex: 'operation',
      //   fixed: 'right',
      //   width: 100,
      //   scopedSlots: { customRender: 'operation' },
      // },
    ];
  }

  opOpinion = [{ value: '', label: '全部' }, { value: '01', label: '时长优惠' }, { value: '02', label: '金额优惠' }];

  toDetail(row: any) {
    if (!row) {
      this.$router.push({
        name: PACKAGE_MANAGEMENT
        // params: {},
        // query: {},
      });
    } else {
      this.$router.push({
        name: COUPON_SEND_LIST
      });
    }
  }
  /**
   * 生命周期钩子函数
   */
  created() {
    // 特殊车辆类型列表初始化
    this.fetchTableData();
  }

  // currPage = 1
  // pageSize = 10
  //table初始化
  current = 1;
  pageSize = 10;
  tableData = [];
  /**
   * 请求列表数据
   */
  async fetchTableData(isRefresh?: boolean) {
    console.log(this.dateTime);
    if (this.tableLoading) return;
    // @ts-ignore
    this.tableLoading = true;
    if (isRefresh) this.current = 1;
    console.log(this.dateTime, '-----======+++++');
    if (this.dateTime.length < 1) {
      this.operateTimeStart = '';
      this.operateTimeEnd = '';
    }
    try {
      const res = await getpageListye({
        merchantId: this.id,
        packageType: this.operateType,
        operateTimeStart: this.operateTimeStart,
        operateTimeEnd: this.operateTimeEnd,
        page: this.current,
        pageSize: this.pageSize
      });
      console.log(res);
      const { data } = res;
      const { datas, totalNum, totalPage, currPage, pageSize } = data;
      // const { datas = [], totalNum = 0 } = data || {}
      this.tableData = data.datas;
      this.total = totalNum - 0;
      // this.current = currPage - 0
      // this.pageSize = pageSize - 0
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    } finally {
      // @ts-ignore
      this.tableLoading = false;
    }
  }

  /**
   * 查询条件清空
   */
  onTableFilterClear() {
    this.dateTime = [];
    this.operateType = '';
    this.fetchTableData(true);
  }

  operateTimeStart = '';
  operateTimeEnd = '';
  // 获取操作时间
  onOperateTime(date: any, dateString: string[]) {
    console.log(date, dateString);
    this.operateTimeStart = dateString[0];
    this.operateTimeEnd = dateString[1];
  }
}
